// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"7e795bfb","102":"4faa42e5","285":"9cb3a4f8","351":"28266b0c","423":"c9b84e2b","553":"5fe81626","618":"d4bae69d","664":"665ccbe6"}[chunkId] + ".js";
};